import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AppointmentsService } from '../../../../services/appointments/appointments.service.js';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTabsModule } from '@angular/material/tabs';
import { SnackbarService } from '../../../../services/snackbar.service.js';
import { PageLoaderService } from '../../../../services/page-loader.service.js';
import { MatDialogRef } from '@angular/material/dialog';
import { SurveyInstance } from "@allaihealth/survey";

/** The survey answer page */
@Component({
	selector: 'app-appointment-answers',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule
	],
	providers: [
		{
			provide: MatDialogRef,
			useValue: {}
		}
	],
	templateUrl: './appointment-answers.component.html',
	styleUrl: './appointment-answers.component.scss'
})
export class AppointmentAnswersComponent implements OnInit {
	@ViewChild("answerJson", {static: true})
	answerJson:ElementRef<HTMLTextAreaElement>;

	position:string = "";

	constructor(private appointmentsService:AppointmentsService,
	            private snackBarService:SnackbarService,
	            private pageLoaderService:PageLoaderService) {
	}

	ngOnInit() {
		this.content = JSON.stringify(this.appointmentsService.appointmentDetail.answers ?? {}, undefined, 4).trim()
	}

	formatJson() {
		try {
			const answers = JSON.parse(this.answerJson.nativeElement.value);
			this.content = JSON.stringify(answers, undefined, 4).trim();
			this.answerJson.nativeElement.scroll({top:0, behavior:"instant"});
		} catch(err) {
			this.snackBarService.error(`JSON is invalid: ${err}`);
			return;
		}
	}

	async saveAnswers() {
		const jsonString = this.answerJson.nativeElement.value;
		let answers:SurveyInstance;

		try {
			answers = JSON.parse(jsonString);
		} catch(err) {
			this.snackBarService.error(`JSON is invalid: ${err}`);
			return;
		}

		this.pageLoaderService.show("Saving...");

		try {
			await this.appointmentsService.saveAnswers(answers);
			this.snackBarService.message("Saved 🎉!");
		} catch(e) {
			console.error("Error saving answers", e);
			this.snackBarService.error(`Error saving answers: ${(<any>e).message}`);
		} finally {
			this.pageLoaderService.close();
		}
	}

	checkKey(event:KeyboardEvent) {
		try {
			const key = event.key;
			if(key.toLowerCase().match(/arrow/)) {
				this.setPosition();
			}
		} catch(ignore) {
		}
	}

	setPosition() {
		try {
			const position = this.answerJson.nativeElement.selectionStart;
			const line = this.answerJson.nativeElement.value.substring(0, position).split("\n").length;
			const column = position - this.answerJson.nativeElement.value.substring(0, position).lastIndexOf("\n");

			this.position = `Line: ${line} Column: ${column} Position: ${position + 1}`;
		} catch(e) {
			console.warn("Failed to set position", e);
		}
	}

	get content() {
		return this.answerJson.nativeElement.value;
	}

	set content(value:string) {
		this.answerJson.nativeElement.value = value;
	}

	async completeSurvey() {
		this.pageLoaderService.show("Completing survey...");

		try {
			await this.appointmentsService.completeSurvey();
			this.snackBarService.message("Survey completed.");
		} catch(e) {
			this.snackBarService.error(`Error completing survey: ${(<any>e).message}`);
		} finally {
			this.pageLoaderService.close();
		}

	}
}
